import React from 'react';
import classNames from 'classnames';

import Icon, { IconNames } from './presenter';

import { iconDefaultProps, iconPropTypes } from './iconPropTypes';


const SearchIcon = ({ className, size, ...rest }) => (
  <Icon
    className={classNames({
      'j-icon-search': true,
      [className]: className,
    })}
    name={IconNames.SEARCH}
    size={size}
    {...rest}
  />
);

SearchIcon.propTypes = {
  ...iconPropTypes,
};

SearchIcon.defaultProps = {
  ...iconDefaultProps,
};


export default SearchIcon;
